import axios from 'axios';
// import rax from 'retry-axios';
import apiConfig from './apiConfig';
import LoginService from './login/LoginService';

const rax = require('retry-axios');

export const client = axios.create({
	baseURL: apiConfig.api.base,
});

export const interceptorId = rax.attach(client);

export const request = (options, auth) => {
	let opt = {
		withCredentials: true,
		raxConfig: {
			retry: 3,
			// Retry twice on errors that don't return a response (ENOTFOUND, ETIMEDOUT, etc).
			noResponseRetries: 2,
			retryDelay: 3000,
			// httpMethodsToRetry: ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT'],
			statusCodesToRetry: [504],
			instance: client,
			onRetryAttempt: err => {
				const cfg = rax.getConfig(err);
				console.log(`Retry attempt #${cfg.currentRetryAttempt}`);
			},
		},
		...options,
	};

	if (auth) {
		if (LoginService.getToken('token')) {
			opt = {
				...opt,
				headers: {
					Authorization: `Bearer ${LoginService.getToken('token')}`,
				},
			};
		}
	}

	const onSuccess = response => {
		console.debug('Request Successful!', response);
		return response.data;
	};

	const onError = error => {
		return Promise.reject(error);
	};

	return client(opt)
		.then(onSuccess)
		.catch(onError);
};
